import s3URL from '@mathflat/common/util/s3'
import type { Banner as BannerData } from '@mathflat/domain/Notice'
import { isAfter } from 'date-fns'
import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { getContractUrl } from 'src/constant'

import commonRepo from '@/repository/common.repo'

import type { User } from '../Teacher'

export class Banner {
  id: string
  tooltipImageUrl = s3URL.mathflatAssetsBucket.teacher('images/banners/tooltip_default.png')
  tooltipTextColor = '#003D5B'
  longImageUrl = s3URL.mathflatAssetsBucket.teacher('images/banners/long_default.png')
  redirectUrl?: string
  longImagePrimaryColor = '#003D5B'
  longImageSecondaryColor = '#003D5B'
  isTimerTextVisible = true
  private _expiredAt = new Date()

  get expiredAt() {
    // 방어코드 목적. 실제로 이런 케이스가 발생하지는 않을 수 있음.
    if (isAfter(new Date(), this._expiredAt)) {
      if (!commonRepo.academy?.freeEndDate) {
        return new Date()
      }

      return new Date(+new Date(commonRepo.academy.freeEndDate) + 15 * 60 * 60 * 1000)
    }

    return this._expiredAt
  }

  getNowAndExpiredAtDiff() {
    const time = this.expiredAt.getTime() - new Date().getTime()
    return time
  }

  constructor({ user, data, id = nanoid() }: { user: User; data?: BannerData; id?: string }) {
    makeAutoObservable(this)

    this.id = id

    if (data) {
      this._expiredAt = new Date(data.expiredAt)
      this.isTimerTextVisible = data.isTimerTextVisible

      this.tooltipImageUrl = data.tooltipImageUrl
      this.longImageUrl = data.longImageUrl
      this.tooltipTextColor = data.tooltipTextColor
      this.longImagePrimaryColor = data.longImagePrimaryColor
      this.longImageSecondaryColor = data.longImageSecondaryColor
      this.redirectUrl = data.redirectUrl ?? undefined
    } else {
      if (commonRepo.academy?.freeEndDate) {
        this._expiredAt = new Date(+new Date(commonRepo.academy.freeEndDate) + 15 * 60 * 60 * 1000)
      }
    }

    if (!this.redirectUrl) {
      this.redirectUrl = getContractUrl(user)
    }
  }
}
